import React, { Fragment } from 'react'
import OTPPage from '../../Components/Auth/OTPPage'

const OTP = () => {
    return (
        <Fragment >
            <OTPPage />
        </Fragment>
    )
}

export default OTP